import { siteStats } from "@/mocks/anime";

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20anime%20style%20painterly%20illustration%20of%20a%20warm%20golden%20sunset%20sky%20with%20soft%20drifting%20clouds%20and%20glowing%20light%20rays%20above%20a%20distant%20city%20skyline%20silhouette%2C%20cinematic%20warm%20orange%20cream%20and%20amber%20palette%2C%20no%20text%2C%20high%20detail%20decorative%20background&width=1920&height=1080&seq=anime-hero-91&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60" />
      </div>

      <div className="relative w-full max-w-6xl mx-auto px-4 md:px-6 pt-32 pb-12 md:pt-44 md:pb-16">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium bg-background-50/15 text-background-50 border border-background-50/30">
            <i className="ri-fire-line" />
            本周更新的热门番剧与新番清单
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-snug text-background-50">
            91动漫排行榜：热门番剧与新番推荐，好看动漫一网打尽
          </h1>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-100/90 max-w-2xl">
            这里整理了当下讨论度最高的热门番剧、正在更新的新番，以及覆盖各类题材的好看动漫排行榜。
            无论你是追了很多年的老番迷，还是刚刚入坑的新观众，都能通过题材分类和编辑评分，快速找到值得点开的那一部。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#ranking"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-trophy-line" />
              查看热门排行
            </a>
            <a
              href="#new"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-background-50/10 text-background-50 border border-background-50/40 text-sm font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              <i className="ri-calendar-check-line" />
              本季新番推荐
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="flex items-center gap-3 px-4 py-3 rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-lg shrink-0">
                <i className={stat.icon} />
              </span>
              <div className="min-w-0">
                <p className="font-heading text-lg font-semibold text-background-50 leading-tight">
                  {stat.value}
                </p>
                <p className="text-xs text-background-100/80 truncate">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}